import { render, staticRenderFns } from "./SystemCommunicationsEmailItem.vue?vue&type=template&id=101118ce&scoped=true"
import script from "./SystemCommunicationsEmailItem.vue?vue&type=script&lang=js"
export * from "./SystemCommunicationsEmailItem.vue?vue&type=script&lang=js"
import style0 from "./SystemCommunicationsEmailItem.vue?vue&type=style&index=0&id=101118ce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "101118ce",
  null
  
)

export default component.exports